import { render, staticRenderFns } from "./PendingRequestModal.vue?vue&type=template&id=c80e7908&scoped=true&"
import script from "./PendingRequestModal.vue?vue&type=script&lang=js&"
export * from "./PendingRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./PendingRequestModal.vue?vue&type=style&index=0&id=c80e7908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80e7908",
  null
  
)

export default component.exports